export default "__VITE_ASSET__fJr14fJM__"